import RegionalLightbox from './RegionalLightbox';

export default RegionalLightbox;
